import { Box, Flex } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { Button, Heading, colors } from 'ui-components';
import { MockMetrics } from '~/components/CreatorChannelMetrics/MockMetrics';
import { SOCIAL_PLATFORMS } from '~/constants';

import { PlatformDemographics } from './PlatformDemographics';

interface Props {
  isDemographicsDisabled: boolean;
  platform: SOCIAL_PLATFORMS;
  slug: string;
  isConnected: boolean;
}

export const AnalyticsEmptyState: React.FC<Props> = ({
  isDemographicsDisabled,
  platform,
  slug,
  isConnected,
}) => {
  const router = useRouter();

  const navigateToConnections = () => {
    router.push(`/t/${slug}/platform-connections`);
  };

  return (
    <Box position="relative">
      <Flex
        width="100%"
        height="100%"
        zIndex={2}
        position="absolute"
        top={0}
        left={0}
        pointerEvents={isConnected ? 'none' : undefined}
        background={`linear-gradient(to bottom, transparent, ${colors.primary[0]} 80%, ${colors.primary[0]} 100%)`}
        alignItems="end"
      >
        <Flex
          flexDirection="column"
          maxWidth={708}
          mx="auto"
          justifyContent="center"
          textAlign="center"
          gap={6}
        >
          <Heading size="sm">
            {!isConnected
              ? 'Add real-time, auto-updating metrics by having the Talent connect their social accounts—no more requesting screenshots.'
              : 'Detailed analytics for this Talent are currently unavailable. Please try again later.'}
          </Heading>
          {!isConnected && (
            <Box>
              <Button size="md" onClick={navigateToConnections}>
                Connect
              </Button>
            </Box>
          )}
        </Flex>
      </Flex>
      <Flex direction="column" gap={6}>
        <PlatformDemographics isDemographicsDisabled={isDemographicsDisabled} />
        <MockMetrics platform={platform} />
      </Flex>
    </Box>
  );
};
